<script setup lang="ts">
import BaseCard from "@/core/components/base/BaseCard.vue";
import {Healthcenter} from "@/core/interfaces/healthcenter/Healthcenter";
import {Dialog, DialogTrigger, DialogHeader, DialogScrollContent, DialogTitle} from "@/core/components/ui/dialog";
import {computed, ref} from "vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {filemanagerFileApi} from "@/container";

const {healthcenter} = defineProps<{ healthcenter: Healthcenter }>();
const emits = defineEmits(['on-image-upload']);
const dialogOpen = ref<boolean>(false);

/** The healthcenter photo URL, if any. */
const photoUrl = computed((): string | null => healthcenter.medias?.[0]?.file?.url ?? null);

/**
 * Open the file upload dialog
 */
const openFileUpload = () => {
    document.getElementById('input-file')?.click();
};

/**
 * Handle the file upload
 *
 * @param {File} file
 */
const handleFileUpload = (file: File | File[]) => {
    filemanagerFileApi().upload(Array.isArray(file) ? file[0] : file)
        .then(file => emits('on-image-upload', file.id));
};
</script>

<template>
  <BaseCard class="p-4">
    <h2>Photo</h2>
    <div v-if="photoUrl" class="pt-4">
      <Dialog :open="dialogOpen" @update:open="(value) => dialogOpen = value">
        <DialogTrigger class="cursor-pointer">
          <img :src="photoUrl" class="h-24 w-48">
        </DialogTrigger>
        <DialogScrollContent>
          <DialogHeader>
            <DialogTitle>
              Mettre à jour votre photo
            </DialogTitle>
          </DialogHeader>
          <div class="flex flex-col items-center justify-center gap-3">
            <img :src="photoUrl" class="h-48 w-96">
            <div class="flex flex-row">
              <BaseButton primary prepend-icon="mdi-upload" @click="openFileUpload()">
                Remplacer la photo
              </BaseButton>
              <v-file-input
                v-show="false"
                id="input-file"
                accept="image/*"
                @update:model-value="handleFileUpload"
              />
            </div>
          </div>
        </DialogScrollContent>
      </Dialog>
    </div>
    <div v-else>
      <Dialog :open="dialogOpen" @update:open="(value) => dialogOpen = value">
        <DialogTrigger class="cursor-pointer">
          <BaseButton primary>
            Ajouter une photo
          </BaseButton>
        </DialogTrigger>
        <DialogScrollContent>
          <DialogHeader>
            <DialogTitle>
              Mettre à jour votre photo
            </DialogTitle>
          </DialogHeader>
          <div class="flex flex-col items-center justify-center gap-3">
            <div class="flex flex-row">
              <BaseButton primary prepend-icon="mdi-upload" @click="openFileUpload()">
                Ajouter une photo
              </BaseButton>
              <v-file-input
                v-show="false"
                id="input-file"
                accept="image/*"
                @update:model-value="handleFileUpload"
              />
            </div>
          </div>
        </DialogScrollContent>
      </Dialog>
    </div>
  </BaseCard>
</template>
